import styled from 'styled-components';

export const OptionStyled = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: inherit;

  ${({ isDisabled }) =>
    isDisabled &&
    `
    font-style: italic;
    color: var(
    --ds-soldevelo-select-option-disabled-font,
    var(--ds-fb-soldevelo-select-option-disabled-font));
  `}
`;

export const UserStyled = styled.div`
  display: flex;
  align-items: center;
`;

export const UserPickerAvatarWrapper = styled.div`
  padding-right: 4px;
`;
